<template>
  <dialog-scroll-lock v-if="status" width="500" :value="true" @input="$emit('close')">
    <v-card>
      <v-card-title class="px-4">
        <div v-if="status.isDirty">Your changes have been saved</div>
        <div v-else>Project status</div>
        <v-spacer />
        <v-btn icon @click="$emit('close')">
          <v-icon v-html="mdiClose" />
        </v-btn>
      </v-card-title>
      <v-card-subtitle class="px-4">
        <slot>
          <!-- This message is geared towards standalone group videos and can be overridden -->
          Revisit this page at any time to make more changes
        </slot>
      </v-card-subtitle>
      <group-video-status class="pb-6" :status="status" />
      <v-divider />
      <v-card-actions>
        <v-spacer />
        <v-btn @click="$emit('continue')">Continue editing</v-btn>
        <v-btn color="primary" @click="$emit('close')">Close</v-btn>
      </v-card-actions>
    </v-card>
  </dialog-scroll-lock>
</template>


<script>
import GroupVideoStatus from '@/components/GroupVideoStatus.vue';
import { mdiClose } from '@mdi/js';


export default {
  name: 'group-video-status-dialog',

  components: {
    GroupVideoStatus
  },

  props: [ 'status' ],

  data() {
    return { mdiClose };
  }
}
</script>
